// extracted by mini-css-extract-plugin
var _1 = "AnnotationLink-module__animatedBackground--Xhr2r";
var _2 = "AnnotationLink-module__container--hmebr";
var _3 = "AnnotationLink-module__icon--ou1RY";
var _4 = "AnnotationLink-module__link--w9ZkS";
var _5 = "AnnotationLink-module__linkText--pu6xI";
export { _1 as "animatedBackground", _2 as "container", _3 as "icon", _4 as "link", _5 as "linkText" }
